import {AbstractControl, FormControl} from '@angular/forms';

export enum ResultFieldTypes {
    NUMERIC = 'numberFields',
    TEXT = 'textFields',
    SINGLE_SELECT = 'selectFields',
    MULTI_SELECT = 'selectFields',
    CHECKBOX = 'checkboxFields',
    IMAGE = 'mediaFields',
    VIDEO = 'mediaFields',
    IMAGE_VIDEO = 'mediaFields',
    SIGNATURE = 'mediaFields',
    ISSUES = 'issueFields',
    TABLE = 'TABLE',
    TABLE_NUMBER_COLUMNS = 'tableNumberColumns',
    TABLE_TEXT_COLUMNS = 'tableTextColumns',
}
export enum TableFieldType {
    TABLE_NUMBER_COLUMNS = 'TABLE_NUMBER_COLUMNS',
    TABLE_TEXT_COLUMNS = 'TABLE_TEXT_COLUMNS',
}
export enum ButtonActionType {
    Next = 'next',
    Prev = 'prev',
}
export interface TrackProgress {
    total: number;
    completed: number;
}

export interface TableValidation {
    totalRequiredValues: TotalRequiredValues[];
    totalRequiredAndValid: TotalRequiredAndValid[];
    totalInvalidFields: string[];
}

export interface TotalRequiredValues {
    control: FormControl | AbstractControl;
    id: string;
}

export interface TotalRequiredAndValid {
    control: FormControl | AbstractControl;
    id: string;
}
